import * as React from "react";
import styled from "styled-components";

import { MobileNav } from "./mobile/MobileNav";
import { AccountNav } from "./AccountNav/AccountNav";
import { DropdownMenu } from "./DropdownMenu/DropdownMenu";

import { BorderedNavLink } from "./NavLink";
import { BREAK_POINTS } from "../../consts/style";
import { IMenuItem } from "./IMenuItem";
import { addTrackingToNavigation } from "./navService";
import { Logo } from "../Svg/Logo";

const Nav = styled.nav`
  background: white;
  max-height: 64px;
  position: relative;
  @media (min-width: ${BREAK_POINTS.MIN.MD}) {
    max-height: 136px;
    height: 136px;
  }
`;

export const LogoLink = styled(BorderedNavLink)`
  padding: 7px;
  top: 0;
  left: 0;
  width: 64px;
  height: 64px;
  z-index: 1000;
  float: left;
  position: relative;

  & > svg {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    padding: 8px;
    box-sizing: border-box;
  }

  @media (min-width: ${BREAK_POINTS.MIN.MD}) {
    padding: 14px;
    height: 136px;
    width: 101px;
    & > svg {
      padding: 14px;
      height: 100%;
      width: 100%;
    }
  }
`;

const DesktopNav = styled.div`
  display: none;
  width: 100%;
  @media (min-width: ${BREAK_POINTS.MIN.MD}) {
    display: block;
  }
`;

const UpperNavContainer = styled.div`
  border-bottom: 1px solid #f1f1f1;
  height: 48px;
`;

const UpperNavContainer2 = styled(UpperNavContainer)`
  flex-shrink: 0;
  @media (min-width: ${BREAK_POINTS.MIN.LG}) {
    flex-basis: 450px;
  }
`;

const AccountLinks = styled.div``;
const NavContainer = styled.div``;
const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const FlexFillLrg = styled(UpperNavContainer)`
  display: none;
  @media (min-width: ${BREAK_POINTS.MIN.LG}) {
    display: block;
    flex-grow: 1;
  }
`;

const FlexFill = styled(UpperNavContainer)`
  display: block;
  flex-grow: 1;
`;

interface Props {
  menuItems: IMenuItem[];
  activeTopMenuIndex: number;
  activeDropdownMenuIndex: number;
}

export const Navigation = ({
  menuItems = [],
  activeTopMenuIndex,
  activeDropdownMenuIndex
}: Props) => {
  const trackedMenus = addTrackingToNavigation(menuItems);

  return (
    <Nav>
      <DesktopNav data-comments="DesktopNav">
        <LogoLink href="/">
          <Logo id="desktop-nav" />
        </LogoLink>
        <FlexContainer>
          <FlexFillLrg />
          <NavContainer>
            <UpperNavContainer>
              {trackedMenus.map((topMenu, index) => (
                <BorderedNavLink
                  tracking={topMenu.tracking}
                  key={index}
                  href={topMenu.link}
                  className={index === activeTopMenuIndex ? "active" : ""}
                >
                  <span>{topMenu.title}</span>
                </BorderedNavLink>
              ))}
            </UpperNavContainer>
            <DropdownMenu
              menuItems={trackedMenus[activeTopMenuIndex].children || []}
              activeMenuIndex={activeDropdownMenuIndex}
            />
          </NavContainer>
          <FlexFill />
          <UpperNavContainer2 data-comment="desktop-nav-upper-2">
            <AccountLinks>
              <AccountNav
                text="See our plans"
                href="/for-home/electricity-and-gas/plans/energy-plans.html"
              />
            </AccountLinks>
          </UpperNavContainer2>
        </FlexContainer>
      </DesktopNav>
      <MobileNav menuItems={trackedMenus} />
    </Nav>
  );
};
